export const removeSelection = () => {
  if (window.getSelection) {
    if (window.getSelection().empty) {
      // Chrome
      window.getSelection().empty()
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      window.getSelection().removeAllRanges()
    }
  } else if (document.selection) {
    // IE?
    document.selection.empty()
  }
}

/**
 * get the first scroll parent of an element
 * @param  {DOM} elm    cache element for recursive search
 * @return {DOM}        the first scroll parent
 */
export const getScrollParent = elm => {
  let result

  if (elm.tagName === 'BODY') {
    result = window
  } else if (['scroll', 'auto'].indexOf(getComputedStyle(elm).overflowY) > -1) {
    result = elm
  }

  return result || getScrollParent(elm.parentNode)
}

/**
 * @param {Object} options
 * @param {HTMLElement | null} options.element
 * @param {boolean} [options.checkXAxis]
 * @param {boolean} [options.checkYAxis]
 * @returns {boolean}
 */
export const isElementInViewPort = ({
  element = null,
  checkXAxis = true,
  checkYAxis = true
} = {}) => {
  if (!element) return true
  if (!checkXAxis && !checkYAxis) return true

  const { top, left, bottom, right } = element.getBoundingClientRect()

  const isInViewByXAxis = checkXAxis
    ? left >= 0 && right <= (window.innerWidth || document.documentElement.clientWidth)
    : true

  const isInViewByYAxis = checkYAxis
    ? top >= 0 && bottom <= (window.innerHeight || document.documentElement.clientHeight)
    : true

  return isInViewByXAxis && isInViewByYAxis
}

export const ELEMENT_VISIBILITY_CHECK_MODE = {
  VIEWPORT: 'viewport',
  SCROLLABLE_PARENT: 'scrollableParent'
}

export const isVisibleInScrollableParent = ({
  element = null,
  mode = ELEMENT_VISIBILITY_CHECK_MODE.SCROLLABLE_PARENT
} = {}) => {
  if (!element) return true

  if (mode === ELEMENT_VISIBILITY_CHECK_MODE.VIEWPORT) {
    return isElementInViewPort({
      element,
      checkXAxis: false
    })
  }

  const parent = getScrollParent(element)
  const topIsVisible =
    element.offsetTop > parent.scrollTop &&
    element.offsetTop < parent.scrollTop + parent.offsetHeight
  const bottomIsVisible =
    element.offsetTop + element.offsetHeight > parent.scrollTop &&
    element.offsetTop + element.offsetHeight < parent.scrollTop + parent.offsetHeight

  return topIsVisible && bottomIsVisible
}

/**
 * stashing of old window scroll Y position and scroll window to it
 *  cause .scrollIntoView() method can't scroll only by one axes
 * @param {HTMLElement} element element what we want to scroll
 * @param {object} options options for native scrollIntoView function
 * @returns void
 */
export const scrollIntoViewOnlyHorizontally = (element, options) => {
  const prevWindowScrollYPosition = window.scrollY
  element.scrollIntoView(options)
  window.scrollTo({
    top: prevWindowScrollYPosition
  })
}
